import React from 'react';
import AiChatBot from '../AiChatBot/AiChatBot';

// Page « Chat Alex » — interface de chat plein écran (façon AdAmigo) :
// écran d'accueil centré avec suggestions + raccourcis skills, historique via
// le bouton 🕘, réponses par boutons à chaque question fermée d'Alex.
// Toute l'intelligence vit dans AiChatBot (mode embedded + fullPage).
// Pleine largeur ET pleine hauteur : Alex occupe tout l'espace du dashboard.
const AlexChatPage = () => (
  <div className="h-[calc(100vh-140px)] md:h-[calc(100vh-70px)] w-full -m-2 md:m-0">
    <AiChatBot embedded fullPage />
  </div>
);

export default AlexChatPage;
